// @NOTE-DP: keep in-sync with marketplace/packages/goodera-sdk/src/enums.ts
export const languages = {
  Khmer: 'KHM',
  Chinese: 'CHI',
  Arabic: 'ARA',
  Afrikaans: 'AFR',
  Russian: 'RUS',
  Portuguese: 'POR',
  Oriya: 'ORI',
  Czech: 'CZECH',
  Polish: 'POL',
  Amharic: 'AMH',
  Japanese: 'JAP',
  Kannada: 'KAN',
  Bengali: 'BEN',
  Dutch: 'DUT',
  German: 'GER',
  Indonesian: 'IND',
  English: 'ENG',
  Hindi: 'HIN',
  Thai: 'THA',
  Burmese: 'BUR',
  Vietnamese: 'VIE',
  Spanish: 'SPA',
  Sinhala: 'SIN',
  Marathi: 'MAR',
  Mandarin: 'MANDARIN',
  Hebrew: 'HEB',
  Turkish: 'TURKISH',
  Cantonese: 'CANTONESE',
  Ukrainian: 'UKR',
  Romanian: 'ROM',
  SignLanguages: 'SIGN',
  Tamil: 'TAM',
  Italian: 'ITA',
  Malayalam: 'MAL',
  French: 'FRE',
  CapeVerdeanCreole: 'CPF',
  Telugu: 'TEL',
  Punjabi: 'PAN',
  Gujarati: 'GUJ',
  Filipino: 'FIL',
  Urdu: 'URD',
  Korean: 'KOREAN',
  Bulgarian: 'BUL',
  Hungarian: 'HUN',
  Taiwanese: 'TWN',
};
